<template>
  <path d="M20,4A16,16,0,1,0,36,20,16,16,0,0,0,20,4Zm6.943,12.943L17.855,26.03l-4.922-6.563a1.333,1.333,0,1,1,2.133-1.6l3.078,4.1,6.913-6.913a1.333,1.333,0,1,1,1.885,1.885Z" transform="translate(-4 -4)"/>
</template>
